<script setup lang="ts">
import TabCreatePostDefault from '@assets/images/bottom-tab-create-post-default.svg?url'
</script>

<template>
  <button type="button" class="nova-create-post-button">
    <img :src="TabCreatePostDefault" alt="" />
  </button>
</template>

<style scoped lang="scss">
.nova-create-post-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  font-size: 0;
  background: linear-gradient(180deg, #3c9ecf 0%, #213acc 100%);
  border-radius: 50%;
  box-shadow: 0 4px 4px 0 #00000026;
}
</style>
